import { Action, Selector, State, StateContext, Store } from "@ngxs/store";
import { MessageStateModel } from "./message-model";
import { Injectable } from "@angular/core";
import { Messages } from "./message-actions";
import { MessagingService } from "../../services/messaging.service";
import { lastValueFrom } from "rxjs";
import { patch, updateItem } from "@ngxs/store/operators";
import { ClientMessageHeader } from "../../models/client-message";
import { Users } from "../user/user-actions"

@State<MessageStateModel>
(
    {
        name: "messages",
        defaults: 
        {
            loadedMessages: []
        }
    }
)

  @Injectable({ providedIn: 'root' })
  export class MessagesState 
  {

    constructor
    (
        private _messageService: MessagingService,
    )
    {

    }

    @Selector()
    static undeliveredMessages(state: MessageStateModel) 
    {
      return state.loadedMessages.filter(s => !s.delivered);
    }


    @Selector()
    static messages(state: MessageStateModel)
    {
      return state.loadedMessages;
    }

    @Selector()
    static unreadCount(state: MessageStateModel)
    {
      return state.loadedMessages.filter(m => !m.read).length;
    }

    @Action([Users.UserLoggedIn])
    async userLoggedIn(ctx: StateContext<MessageStateModel>, action: Users.UserLoggedIn)
    {
        const state = ctx.getState();
        let messages = await lastValueFrom(this._messageService.getMessages());
        ctx.setState
        (
            {
                ...state,
                loadedMessages: messages,
            }
        );
        ctx.dispatch(new Messages.InitialMessagesLoaded())
    }

    @Action([Messages.InitialMessagesLoaded])
    async initialMessagesLoaded(ctx: StateContext<MessageStateModel>)
    {
        //Update any that hadn't previously been delivered
        const state = ctx.getState();
        let undeliveredMessages = state.loadedMessages.filter(m => !m.delivered);
        undeliveredMessages?.forEach
        (
            m =>
                this._messageService.markMessageAsDelivered(m)
        );
    }

    @Action([Messages.NewMessageReceived])
    async newMessageReceived(ctx: StateContext<MessageStateModel>, action:Messages.NewMessageReceived)
    {
        const state = ctx.getState();
        ctx.setState
        (
            {
                ...state,
                loadedMessages: [...state.loadedMessages, action.payload.message]
            }
        );
    }

    @Action([Messages.MessageDeliveryConfirmed])
    async deliveryConfirmed(ctx: StateContext<MessageStateModel>, action:Messages.MessageDeliveryConfirmed)
    {
        //replace the updated message in the state
        let message = action.payload.message;
        const state = ctx.getState();
        
        ctx.setState
        (
            patch<MessageStateModel>
            (
                {
                    loadedMessages: updateItem
                    (
                        item => item.id == message.id,
                        patch<ClientMessageHeader>({delivered:true})
                    )
                }
            )
        )
    }

    @Action([Messages.MessageRead])
    async messageRead(ctx: StateContext<MessageStateModel>, action:Messages.MessageRead)
    {
        //replace the updated message in the state
        let message = action.payload.message;
        const state = ctx.getState();
        
        ctx.setState
        (
            patch<MessageStateModel>
            (
                {
                    loadedMessages: updateItem
                    (
                        item => item.id == message.id,
                        patch<ClientMessageHeader>({read:true})
                    )
                }
            )
        )
    }
  }